import { useMemo } from 'react';
import { useComissaoBundleVisao } from './useComissaoBundleVisao';

/**
 * Cargo histórico de um usuário no mês — lido do BUNDLE da Visão de Comissões
 * (antes era 1 RPC por consultor navegado; virava escadinha de loading).
 * Fallback: cargo atual se não houver registro histórico.
 */
export function useCargoNoMes(
  userId: string | undefined,
  competencia: Date,
  fallbackRole?: string
) {
  const { data: bundle, isLoading } = useComissaoBundleVisao(competencia);
  const cargo = useMemo(() => {
    const hist = userId ? bundle?.cargos?.[userId] : null;
    return hist || fallbackRole || 'consultor';
  }, [bundle, userId, fallbackRole]);
  return { cargo, isLoading };
}
